// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"72672a25","703":"6ab34229","787":"117dc860"}[chunkId] + ".chunk.js";
};